import { BookingStatus, RegularBooking, SeatReferenceBooking } from '../types';

/**
 * Normalizes seat-reference booking payload shape:
 * maps start/end to startTime/endTime and normalizes status casing.
 */
export function transformSeatReferenceBooking(
    seatBookingData: SeatReferenceBooking
): SeatReferenceBooking {
    return {
        ...seatBookingData,
        startTime: seatBookingData.start,
        endTime: seatBookingData.end,
        status: seatBookingData.status.toUpperCase() as BookingStatus,
    };
}

export function transformRegularBooking(
    regularBookingData: RegularBooking
): RegularBooking {
    return {
        ...regularBookingData,
        hosts: [
            {
                id: regularBookingData?.user?.id,
                name: regularBookingData.user.name,
                email: regularBookingData?.user?.email,
                displayEmail: regularBookingData?.user?.email,
                username: regularBookingData?.user?.username,
            },
        ],
    };
}
